import styles from "./CheckoutForm.module.css";
import { useContext, useEffect, useState } from "react";
import Modal from "../../../UI/Modal";
import Input from "../../../UI/Input";
import Button from "../../../UI/Button";
import exit from "../../../../assets/x-highlight.png";
import PostStatusFeedback from "../../../UI/PostStatusFeedback";

export default function CheckoutForm({
  onClose,
  items,
  respStatus,
  postOrder,
  dataCtx,
}) {
  const [forBusiness, setForBusiness] = useState(false);

  // main section
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);

  const [surname, setSurname] = useState("");
  const [surnameError, setSurnameError] = useState(false);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  //business section
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState(false);

  const [companyID, setCompanyID] = useState("");
  const [companyIDError, setCompanyIDError] = useState(false);

  // address section
  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState(false);

  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");

  const [zip, setZip] = useState("");
  const [zipError, setZipError] = useState(false);

  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState("");

  const [additional, setadditional] = useState("");
  const [additionalError, setadditionalError] = useState(false);

  const [imNotARobot, setImNotARobot] = useState(false);

  const sendEmailHandler = (e) => {
    e.preventDefault();

    if (name.length === 0 || name.length > 50) {
      setNameError(true);
      return;
    }

    if (surname.length === 0 || surname.length > 50) {
      setSurnameError(true);
      return;
    }

    if (
      email.length === 0 ||
      email.length > 50 ||
      !email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      setEmailError(true);
      return;
    }

    if (phoneNumber.length === 0 || phoneNumber.length > 20) {
      setPhoneNumberError(true);
      return;
    }

    if (forBusiness) {
      if (companyName.length === 0 || companyName.length > 100) {
        setCompanyNameError(true);
        return;
      }

      if (companyID.length === 0 || companyID.length > 15) {
        setCompanyIDError(true);
        return;
      }
    }

    if (address.length === 0 || address.length > 100) {
      setAddressError(true);
      return;
    }

    if (zip.length === 0 || zip.length > 10) {
      setAddressError(true);
      return;
    }

    if (city.length === 0 || city.length > 50) {
      setCityError(true);
      return;
    }

    if (country.length === 0 || country.length > 50) {
      setCountryError(true);
      return;
    }

    const data = {
      set_paid: true,
      hp_check: imNotARobot,
      billing: {
        first_name: name,
        last_name: surname,
        address_1: address,
        address_2: additional,
        company: forBusiness ? companyName + " oib: " + companyID : "-",
        city: city,
        postcode: zip,
        country: country,
        email: email,
        phone: phoneNumber,
      },
      line_items: items.map((item) => {
        return { product_id: item.id, quantity: item.quantity };
      }),
    };

    postOrder(data);
  };

  return (
    <Modal onClose={onClose}>
      <main className={styles.main}>
        <img className={styles.exit} src={exit} alt="X" onClick={onClose} />
        <PostStatusFeedback
          respStatus={respStatus}
          success={dataCtx.pageData.contact.send_success}
          fail={dataCtx.pageData.contact.send_error}
        />
        <form className={styles.form} onSubmit={sendEmailHandler}>
          <div className={styles.title}>
            {dataCtx.pageData.contact.cart_contact_title}
          </div>

          <div className={styles[`main-section`]}>
            <div className={styles[`dual`]}>
              <Input
                setValue={setName}
                value={name}
                label={dataCtx.pageData.contact.name}
                error={nameError}
                setError={setNameError}
              />
              <Input
                setValue={setSurname}
                value={surname}
                label={dataCtx.pageData.contact.surname}
                error={surnameError}
                setError={setSurnameError}
              />
            </div>
            <Input
              setValue={setEmail}
              value={email}
              label={dataCtx.pageData.contact.email}
              error={emailError}
              setError={setEmailError}
              type="email"
            />

            <Input
              setValue={setPhoneNumber}
              value={phoneNumber}
              label={dataCtx.pageData.contact.phone}
              error={phoneNumberError}
              setError={setPhoneNumberError}
              type="number"
            />

            <label className={styles[`business-check`]}>
              <input
                type="checkbox"
                value={dataCtx.pageData.contact.r1}
                onChange={(e) => {
                  setForBusiness(e.target.checked ? true : false);
                }}
              />
              {dataCtx.pageData.contact.r1}
            </label>

            {forBusiness && (
              <div className={styles[`business-section`]}>
                <Input
                  setValue={setCompanyName}
                  value={companyName}
                  label={dataCtx.pageData.contact.company_name}
                  error={companyNameError}
                  setError={setCompanyNameError}
                />

                <Input
                  setValue={setCompanyID}
                  value={companyID}
                  label={dataCtx.pageData.contact.company_id}
                  error={companyIDError}
                  setError={setCompanyIDError}
                  type="number"
                />
              </div>
            )}
          </div>
          <div className={styles.devider} />
          <div className={styles[`address-section`]}>
            <div className={styles.dual}>
              <Input
                setValue={setAddress}
                value={address}
                label={dataCtx.pageData.contact.address}
                error={addressError}
                setError={setAddressError}
              />

              <Input
                setValue={setCity}
                value={city}
                label={dataCtx.pageData.contact.city}
                error={cityError}
                setError={setCityError}
              />
            </div>
            <div className={styles.dual}>
              <Input
                setValue={setZip}
                value={zip}
                label={dataCtx.pageData.contact.zip}
                error={zipError}
                setError={setZipError}
                type="number"
              />
              <Input
                setValue={setCountry}
                value={country}
                label={dataCtx.pageData.contact.country}
                error={countryError}
                setError={setCountryError}
              />
            </div>
            <Input
              isTextArea={true}
              setValue={setadditional}
              value={additional}
              label={dataCtx.pageData.contact.additional_info}
              error={additionalError}
              setError={setadditionalError}
            />

            <input
              id="ImNotArobot"
              name="ImNotArobot"
              type="checkbox"
              checked={imNotARobot}
              onChange={(e) => {
                setImNotARobot(e.target.checked);
              }}
              tabIndex="-1"
              autoComplete="off"
              style={{
                position: "absolute",
                left: "-9999px",
                width: "1px",
                height: "1px",
                overflow: "hidden",
              }}
            />
            <div className={styles[`button-container`]}>
              <Button type="submit">
                {dataCtx.pageData.contact.send_button}
              </Button>
            </div>
          </div>
        </form>
      </main>
    </Modal>
  );
}
